import { breakpoints, Button, Dialog, Inline, Stack } from '@etg/wings';
import type { FormEvent } from 'react';
import { useState } from 'react';
import { useTranslation } from '@eti/providers';
import { capitalize } from '../utils';
import RadioSelection from './common/RadioSelection';
import { DebugButton } from './index';
import InputSelection from './common/InputSelection';

const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
  const formData = new FormData(event.currentTarget);
  const formEntries = Array.from(formData.entries());

  for (const [key, value] of formEntries) {
    sessionStorage.setItem(`mocked${capitalize(key)}`, String(value));
  }
};

const DebugSupportPage = () => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <DebugButton
        data-testid="support-properties-button"
        onClick={() => {
          setIsDialogOpen(true);
        }}
      >
        Support properties
      </DebugButton>
      <Dialog
        closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
        footer={
          <Inline align="end" collapseBelow={breakpoints._560}>
            <Button
              name="supportPageAppendTtuuid"
              value="yes"
              variant="secondary"
              data-testid="support-properties-save-and-append-button"
              form="supportPropertiesConfigForm"
              type="submit"
            >
              Save and append ttuuid
            </Button>
            <Button
              data-testid="support-properties-save-button"
              form="supportPropertiesConfigForm"
              type="submit"
              variant="primary"
            >
              Save
            </Button>
          </Inline>
        }
        isOpen={isDialogOpen}
        onDismiss={() => {
          setIsDialogOpen(false);
        }}
        title="Support properties"
      >
        <form
          action="/debug.supportproperties.mock.config"
          id="supportPropertiesConfigForm"
          method="POST"
          onSubmit={handleSubmit}
        >
          <Stack>
            <RadioSelection
              defaultValue="yes"
              id="isSupportPageSuccess"
              label="Should the support page GraphQL query be successful?"
            />
            <InputSelection
              defaultValue="app_6a20377ad751b1a8c06c847f"
              id="supportPageKeyId"
              label="Zendesk key id"
            />
            <InputSelection defaultValue="" id="supportPageJwtSecret" label="Zendesk JWT secret" />
            <InputSelection
              defaultValue="en"
              id="supportPageLanguage"
              label="Session language (empty for none)"
            />
            <InputSelection
              defaultValue="c328d7f8-2608-4b52-b5a4-e49c4a76c6e1"
              id="supportPageZendeskDeploymentKey"
              label="Zendesk deployment key"
            />
          </Stack>
        </form>
      </Dialog>
    </>
  );
};

export default DebugSupportPage;
